<script lang="ts">
    import { H1, Label } from "attractions";
    import Currency from "../../../Utils/Currency";

    export let counter;
    export let sum;
</script>

<section class="clearanceSummary">
    <div class="card">
        <Label small style="margin-bottom: .25rem">Wartość nierozliczonych zakupów</Label>
        <H1>{sum !== undefined ? Currency.format(sum) : '...'}</H1>
    </div>
    <div class="card">
        <Label small style="margin-bottom: .25rem">Ilość nierozliczonych zakupów</Label>
        <H1>{counter !== undefined ? counter : '...'}</H1>
    </div>
</section>

<style lang="scss">
    .clearanceSummary {
        display: flex;
        
        .card {
            margin-right: 1.5rem;
        }
    }
</style>